module.exports = __webpack_public_path__ + "static/media/tpc_world_boatwords.7a1db2e0.svg";